import React from "react";

import { MonitoringFilterRowPropsType } from "./MonitoringFilterRowTypes";

const MonitoringFilterRow: React.FC<MonitoringFilterRowPropsType> = ({
  columnFilters,
  setColumnFilter,
  filterKeys,
}) => {
  return (
    <tr className="monitoring-filter-row mt-1">
      {filterKeys.map((key) => (
        <th key={key}>
          <div className="monitoring-col-filter">
            <input
              className="monitoring-col-filter-input"
              value={columnFilters[key]}
              onChange={(e) => setColumnFilter(key, e.target.value)}
              placeholder="Поиск"
            />
            {columnFilters[key] && (
              <button
                className="monitoring-col-filter-clear"
                onClick={() => setColumnFilter(key, "")}
                aria-label="Очистить"
              >
                ×
              </button>
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

export default MonitoringFilterRow;
